// extracted by mini-css-extract-plugin
module.exports = {"icon":"ShareButton_icon__Ky1ns"};